import type { ComponentProps } from "react"

export default function PropertyDetachedHouse(
  props: ComponentProps<"svg"> & { fill?: string },
) {
  const { fill = "currentColor", ...svgProps } = props

  return (
    <svg
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...svgProps}
    >
      <path
        d="M28.9427 16.3906L16.9427 4.39063C16.6927 4.14066 16.3536 4.00024 16 4.00024C15.6465 4.00024 15.3074 4.14066 15.0574 4.39063L3.05737 16.3906C2.87096 16.5771 2.74402 16.8146 2.6926 17.0733C2.64117 17.3319 2.66758 17.5999 2.76847 17.8435C2.86936 18.0871 3.04022 18.2953 3.25943 18.4418C3.47864 18.5883 3.73637 18.6666 4.00004 18.6666H6.66671V29.3333H13.3334V22.6666H18.6667V29.3333H25.3334V18.6666H28C28.2637 18.6666 28.5214 18.5883 28.7407 18.4418C28.9599 18.2953 29.1307 18.0871 29.2316 17.8435C29.3325 17.5999 29.3589 17.3319 29.3075 17.0733C29.2561 16.8146 29.1291 16.5771 28.9427 16.3906Z"
        fill={fill}
      />
    </svg>
  )
}
